// extracted by css-extract-rspack-plugin
export default {"wrapper":"_44cdb8c2","container":"_858dc116"};